export default class RequestPromise extends Promise {
	constructor(request, path, data, method = 'GET', params = {}) {
		const state = {};

		super((resolve, reject) => {
			Object.assign(state, { resolve, reject });
		});

		this.then = (...args) => {
			request(path, data, method, params).then(state.resolve, state.reject);
			delete this.then;
			return this.then(...args);
		};

		const [query, body] =
			method.toLowerCase() === 'get' ? [data, {}] : [{}, data];

		this.request = { method, path, query, body };
		this.params = params;
	}

	static get [Symbol.species]() {
		return Promise;
	}

	get [Symbol.toStringTag]() {
		return 'RequestPromise';
	}
}
